import {FC, useEffect, useState} from 'react';
import SubscriptionHead from "./SubscriptionHead/SubscriptionHead";
import {SubscriptionSettingsData} from "./interfaces/SubscriptionSettingsData";
import {useFetching} from "../../hooks/useFetching";
import $api from "../../http";
import {SubscriptionSettingsTranslation} from "./interfaces/SubscriptionSettingsTranslation";
import {Contact} from "./interfaces/Contact";
import {CurrentSubscription} from "./interfaces/Subscription";
import {useQuery} from "../../hooks/useQuery";
import css from './SubscriptionSettings.module.scss';
import HeaderLogo from "../../components/HeaderLogo";
import Switcher from "../../components/Switcher/Switcher";
import Button from "../../elements/Button/Button";
import EmailCircle from '../../elements/EmailCircle/EmailCircle';
import {useNavigate} from "react-router-dom";
import {RouteNames} from "../../router";
import {format} from 'date-fns';

const SubscriptionSettings: FC = () => {

    const [translate, setTranslate] = useState<SubscriptionSettingsTranslation>();
    const [contact, setContact] = useState<Contact>();
    const messageId = useQuery('messageId');
    const [currentSubscriptions, setCurrentSubscriptions] = useState<CurrentSubscription[]>([]);
    const navigate = useNavigate();

    const [fetchSubscriptionData] = useFetching(async (messageId: string) => {
        const response = await $api.get<SubscriptionSettingsData>('/api/Subscription/GetUnsubscribePage', {
            params: {
                messageId
            }
        })
        const {translates, contact, availableSubscriptionGroups} = response.data;
        setTranslate(translates);
        setContact(contact);
        const subscriptions = availableSubscriptionGroups.map((s): CurrentSubscription => {
            const isChecked = contact.cancelledSubscriptions.find(c => c.subscriptionGroupId === s.key)
            return {
                id: s.key,
                value: translates[s.value as keyof typeof translates],
                hint: s.key === 7 ? translates?.SystemEmailsSubstring : null,
                isChecked: !isChecked,
            }
        });
        setCurrentSubscriptions(subscriptions);
    })

    useEffect(() => {
        fetchSubscriptionData(messageId);

        return () => {
            setCurrentSubscriptions([]);
        }
    }, [])

    const saveConfig = async () => {
        const newCancelledSubscription = currentSubscriptions.filter(c => !c.isChecked)
        const availableCancelledSubscriptions = contact!.cancelledSubscriptions.filter(c => newCancelledSubscription.map(n => n.id).includes(c.subscriptionGroupId));
        const subscriptions = newCancelledSubscription.filter(n => !availableCancelledSubscriptions.map(a => a.subscriptionGroupId).includes(n.id))


        subscriptions.forEach(s => {
            availableCancelledSubscriptions.push({
                contactId: contact!.id,
                subscriptionGroupId: s.id,
                comment: null,
                createdOn: format(new Date, 'yyyy-MM-dd HH:mm:ss.SSS'),
            })
        })

        const data: Contact = {
            id: contact!.id,
            name: contact!.name,
            countryCode: contact!.countryCode,
            language: contact!.language,
            deletedOn: contact!.deletedOn,
            cancelledSubscriptions: availableCancelledSubscriptions
        }

        const result = await $api.post('/api/Subscription/UnsubscribeUpdate', data)

        if (result.status === 200) {
            navigate(RouteNames.SUBSCRIPTION_COMMENT + '?messageId=' + messageId)
        }
    }

    return (
        <div className={css.wrapper}>
            <SubscriptionHead title={'Jooble'}/>
            <HeaderLogo className={css.headerLogo}/>
            <main className={css.main}>
                <EmailCircle className={css.main__icon}/>
                <h1 className={css.main__title}>{translate?.ConfigureMailing}</h1>
                <p className={css.main__subTitle}>{translate?.ChooseLetters}</p>
                <Switcher className={css.main__switcher} values={currentSubscriptions}/>
                <Button disabled={!contact} onClick={saveConfig}>{translate?.SaveConfigs}</Button>
            </main>
        </div>
    )
}

export default SubscriptionSettings;
